import type { Sede } from '../lib/api.js';
import { useFilters } from '../lib/filters.js';
import { TIMEFRAME_SPECS } from '../lib/timeframe.js';

export function Filters({ sedes }: { sedes: Sede[] }) {
  const [f, update] = useFilters();

  function toggleSede(id: number) {
    update({ sedes: f.sedes.includes(id) ? f.sedes.filter((x) => x !== id) : [...f.sedes, id] });
  }

  return (
    <div className="flex flex-wrap items-end gap-3 rounded-xl border border-slate-700 bg-slate-800/60 p-3">
      <label className="flex flex-col text-xs text-slate-400">
        Desde
        <input
          type="date"
          value={f.from}
          onChange={(e) => update({ from: e.target.value })}
          className="mt-1 rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-100"
        />
      </label>
      <label className="flex flex-col text-xs text-slate-400">
        Hasta
        <input
          type="date"
          value={f.to}
          onChange={(e) => update({ to: e.target.value })}
          className="mt-1 rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-100"
        />
      </label>

      <div className="flex flex-col text-xs text-slate-400">
        Moneda
        <div className="mt-1 inline-flex overflow-hidden rounded-md border border-slate-700">
          {(['USD', 'BS'] as const).map((cur) => (
            <button
              key={cur}
              onClick={() => update({ currency: cur })}
              className={`px-3 py-1 text-sm ${f.currency === cur ? 'bg-blue-600 text-white' : 'bg-slate-900 text-slate-300'}`}
            >
              {cur}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col text-xs text-slate-400">
        Rango de los gráficos
        <div className="mt-1 inline-flex overflow-hidden rounded-md border border-slate-700">
          {TIMEFRAME_SPECS.map((tf) => (
            <button
              key={tf.value}
              onClick={() => update({ timeframe: tf.value })}
              title={tf.desc}
              className={`px-3 py-1 text-sm ${f.timeframe === tf.value ? 'bg-blue-600 text-white' : 'bg-slate-900 text-slate-300'}`}
            >
              {tf.label}
            </button>
          ))}
        </div>
      </div>

      <label className="flex items-center gap-2 text-sm text-slate-300">
        <input
          type="checkbox"
          checked={f.compare}
          onChange={(e) => update({ compare: e.target.checked })}
        />
        Comparar YoY
      </label>

      <div className="flex flex-1 flex-wrap items-center gap-1">
        {sedes.map((s) => {
          const active = f.sedes.length === 0 || f.sedes.includes(s.id);
          return (
            <button
              key={s.id}
              onClick={() => toggleSede(s.id)}
              title={s.nombre}
              className={`rounded-full border px-2.5 py-1 text-xs ${
                active
                  ? 'border-blue-500 bg-blue-600/20 text-blue-200'
                  : 'border-slate-700 bg-slate-900 text-slate-500'
              }`}
            >
              {s.codigo}
            </button>
          );
        })}
        {f.sedes.length > 0 && (
          <button
            onClick={() => update({ sedes: [] })}
            className="ml-1 text-xs text-slate-400 underline"
          >
            Todas
          </button>
        )}
      </div>
    </div>
  );
}
